import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'renewal.eu.insuredDetailsPage.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    lossOccurredAfterChangeEffectiveDate: {
        id: 'renewal.eu.insuredDetailsPage.Loss Occurred After Change Effective Date',
        defaultMessage: 'A loss for this risk occurred on or after the effective date of the change?'
    },
    lossOccurredAfterEffectiveDate: {
        id: "renewal.eu.insuredDetailsPage.Has any Liability Loss occurred in the household between the effective date and today's date?",
        defaultMessage: "Has any Liability Loss occurred in the household between the effective date and today's date?"
    },
    lossOccurredAfterChangeEffectiveDateYes: {
        id: 'renewal.eu.insuredDetailsPage.Loss Occurred After Change Effective Date.Yes',
        defaultMessage: 'Yes'
    },
    lossOccurredAfterChangeEffectiveDateNo: {
        id: 'renewal.eu.insuredDetailsPage.Loss Occurred After Change Effective Date.No',
        defaultMessage: 'No'
    },
    policyInformation: {
        id: 'renewal.eu.insuredDetailsPage.Policy Information',
        defaultMessage: 'Policy Information'
    },
    lineOfBusiness: {
        id: 'renewal.eu.insuredDetailsPage.Line Of Business',
        defaultMessage: 'Line Of Business'
    },
    periodStartDate: {
        id: 'renewal.eu.insuredDetailsPage.Effective Date',
        defaultMessage: 'Effective Date'
    },
    periodEndDate: {
        id: 'renewal.eu.insuredDetailsPage.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'renewal.eu.insuredDetailsPage.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    riskState: {
        id: 'renewal.eu.insuredDetailsPage.Risk State',
        defaultMessage: 'Risk State'
    },
    policyType: {
        id: 'renewal.eu.insuredDetailsPage.Policy Type',
        defaultMessage: 'Policy type'
    },
    insuredInfo: {
        id: 'renewal.eu.insuredDetailsPage.Insured Information',
        defaultMessage: 'Insured Information'
    },
    insuredFirstName: {
        id: 'renewal.eu.insuredDetailsPage.insuredInformation.FirstName',
        defaultMessage: 'First Name'
    },
    insuredMiddleName: {
        id: 'renewal.eu.insuredDetailsPage.insuredInformation.M.I.',
        defaultMessage: 'M.I.'
    },
    insuredLastName: {
        id: 'renewal.eu.insuredDetailsPage.insuredInformation.LastName',
        defaultMessage: 'LastName'
    },
    insuredSuffix: {
        id: 'renewal.eu.insuredDetailsPage.insuredInformation.Suffix',
        defaultMessage: 'Suffix'
    },
    insuredAddress: {
        id: 'renewal.eu.insuredDetailsPage.Insured Residence Information',
        defaultMessage: 'Insured Residence Address'
    },
    addNewPni: {
        id: 'renewal.eu.insuredDetailsPage.pni.Add New Pni',
        defaultMessage: 'Add New Pni'
    }
});
